import { render, staticRenderFns } from "./PelastuskorttiDialog.vue?vue&type=template&id=662546bc"
import script from "./PelastuskorttiDialog.vue?vue&type=script&lang=js"
export * from "./PelastuskorttiDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports